import { createSelector } from 'reselect';

import { authSelector } from '../utils';

export const autoSigninSelector = createSelector(authSelector, (state) => state.autoSignin);
